import { IconActivity } from '@americanexpress/dls-react';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import LiteralsService from 'src/services/literals/LiteralsService';
import React from 'react';
import { getCategoryTransactionsUrl, goToBudgetCategoryTransactions } from 'src/services/router.service';
import { useHistory } from 'react-router-dom';
import adobeTags from 'src/types/adobe-tags';
import Selectors from 'src/utils/selectors';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { useSyncingAccounts } from 'src/hooks/useSyncingAccounts';
import styles from './TrackerIconButtons.module.scss';
import SkeletonLoader from 'src/components/atomic/atoms/skeletonLoader/SkeletonLoader';

interface TrackerIconButtonsProps {
    budgetGroupId: string;
    budgetGroupName: string;
    className?: string;
    tagName: string;
}

export default function TrackerIconButtons({
    budgetGroupId,
    budgetGroupName,
    className,
    tagName
}: TrackerIconButtonsProps): JSX.Element {
    const { isMinWidthMedium } = useBreakpoints();
    const { isSyncingAccounts } = useSyncingAccounts();
    const history = useHistory();
    if (isSyncingAccounts) return <SkeletonLoader className={`${styles.trackerIconButtonsSkeleton} ${className}`} />;

    return (
        <div className={`${styles.trackerIconButtonsContainer} ${className}`}>
            <Anchor
                onClick={() => goToBudgetCategoryTransactions(false, history, budgetGroupId)}
                tag={`${tagName}-${adobeTags.General.ViewTransactionIcon}`}
                href={getCategoryTransactionsUrl(budgetGroupId)}
                className={styles.linkIconText}
                data-cy={Selectors.SpendSmart.VIEW_TRANSACTIONS_LINK}
                aria-label={LiteralsService.getLiteral('Budget.Current.viewTransactionsLinkDescription', [
                    budgetGroupName
                ])}
            >
                {isMinWidthMedium && <IconActivity className={styles.linkIcon} />}
                {LiteralsService.getLiteral('Budget.Current.viewTransactions')}
            </Anchor>
        </div>
    );
}
